__turbopack_context__.v({
  "closeMenuBtn": "model-module__fAxpnW__closeMenuBtn",
  "container": "model-module__fAxpnW__container",
  "cover": "model-module__fAxpnW__cover",
  "coverInfo": "model-module__fAxpnW__coverInfo",
  "email": "model-module__fAxpnW__email",
  "emails": "model-module__fAxpnW__emails",
  "fadeInItems": "model-module__fAxpnW__fadeInItems",
  "measurement": "model-module__fAxpnW__measurement",
  "measurementValue": "model-module__fAxpnW__measurementValue",
  "measurements": "model-module__fAxpnW__measurements",
  "measurementsWrapper": "model-module__fAxpnW__measurementsWrapper",
  "measurementsWrapperDesktop": "model-module__fAxpnW__measurementsWrapperDesktop",
  "measurementsWrapperMobile": "model-module__fAxpnW__measurementsWrapperMobile",
  "mobileBackBtn": "model-module__fAxpnW__mobileBackBtn",
  "mobileHeader": "model-module__fAxpnW__mobileHeader",
  "mobileInfo": "model-module__fAxpnW__mobileInfo",
  "mobileMenu": "model-module__fAxpnW__mobileMenu",
  "mobileMenuBtn": "model-module__fAxpnW__mobileMenuBtn",
  "mobileMenuItem": "model-module__fAxpnW__mobileMenuItem",
  "mobileMenuLabel": "model-module__fAxpnW__mobileMenuLabel",
  "mobileMenuVisible": "model-module__fAxpnW__mobileMenuVisible",
  "mobileTitle": "model-module__fAxpnW__mobileTitle",
  "shareBtn": "model-module__fAxpnW__shareBtn",
  "shareLink": "model-module__fAxpnW__shareLink",
  "slide": "model-module__fAxpnW__slide",
  "slider": "model-module__fAxpnW__slider",
  "social": "model-module__fAxpnW__social",
  "spacing--lg": "model-module__fAxpnW__spacing--lg",
  "spacing--md": "model-module__fAxpnW__spacing--md",
  "spacing--sm": "model-module__fAxpnW__spacing--sm",
  "spacing--xl": "model-module__fAxpnW__spacing--xl",
  "spacing--xs": "model-module__fAxpnW__spacing--xs",
  "spacing--xxl": "model-module__fAxpnW__spacing--xxl",
  "spacing--xxs": "model-module__fAxpnW__spacing--xxs",
  "spacing--xxxl": "model-module__fAxpnW__spacing--xxxl",
  "spacing--xxxs": "model-module__fAxpnW__spacing--xxxs",
  "title": "model-module__fAxpnW__title",
  "toggleEmails": "model-module__fAxpnW__toggleEmails",
  "toggleEmailsVisible": "model-module__fAxpnW__toggleEmailsVisible",
});
